/*
 * 作者: Fultom
 * 创建时间: 2023-09-14 13:51:04
 * 最近修改时间: 2024-05-17 14:34:36
 * 功能:
 */
const _import = require('./_import_' + process.env.NODE_ENV);

const orderPage = [

  // 订货会门票
  {
    path: '/orderTicket',
    name: 'orderTicket',
    component: _import('ticketInfo/orderPage/index'),
    hidden: true,
    meta: {
      title: '门票',
    }
  },
  {
    path: '/myTicket',
    name: 'myTicket',
    component: _import('ticketInfo/myTicket/index'),
    hidden: true,
    meta: {
      title: '我的票'
    }

  },
  {
    path: '/detailInfo',
    name: 'detailInfo',
    component: _import('ticketInfo/detailInfo/index'),
    hidden: true,
    meta: {
      title: '盒数明细'
    }
  },
  {
    path: '/maintainTicket',
    name: 'maintainTicket',
    component: _import('ticketInfo/maintainTicket/index'),
    hidden: true,
    meta: {
      title: '维护门票信息'
    }
  },
]

export default orderPage;



// WEBPACK FOOTER //
// ./src/router/orderPage.js